import React from 'react';
import {
  createBrowserRouter,
  RouterProvider
} from "react-router-dom";

import {
  Search,
  Product,
  SearchResults,
} from './pages';
import { ErrorBoundary } from './components';


function App({ auth }) {
  const router = createBrowserRouter([
    {
      path: "/",
      element: <Search auth={auth} />
    },
    {
      path: "produto/:id_sku",
      element: <Product auth={auth} />
    },
    {
      path: "busca/",
      element: <SearchResults auth={auth} />
    }
  ]);

  return (
    <ErrorBoundary>
      <RouterProvider router={router} />
    </ErrorBoundary>
  );
}

export default App;
